import nestAxios from 'services/_nestAxios'
import inveAxios from 'services/_inveAxios'

const getData = ({ useNest, useInve }, { url, params }) => {
  if (useInve) {
    return inveAxios.get(url, { params })
  } else {
    return nestAxios.get(url, { params })
  }
}

const salida = {
  getData
}

export default salida
